import { create } from "zustand";

export enum SystemStatus {
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  FAIL = "FAIL",
}

interface SystemStatusState {
  status: SystemStatus;
  setStatus: (status: SystemStatus) => void;
  elapsedTime: number;
  setElapsedTime: (elapsedTime: number) => void;
  isVersionMatched: boolean;
  setIsVersionMatched: (version: boolean) => void;
}

const init = {
  status: SystemStatus.SUCCESS,
  elapsedTime: 0,
  isVersionMatched: true,
};

const useSystemStatusStore = create<SystemStatusState>((set) => ({
  ...init,
  setStatus: (status: SystemStatus) => set({ status }),
  setElapsedTime: (elapsedTime: number) => set({ elapsedTime }),
  setIsVersionMatched: (isVersionMatched: boolean) => set({ isVersionMatched }),
}));

export default useSystemStatusStore;
